<template>
  <div class="col_group">
    <template v-for="(category, categoryIdx) in column" v-if="!isEmpty(category)">
      <a :key="category.productUiId" @click="toggleCollapse(category)" :class="{ collapsed: !category.showCollapse }" :aria-controls="`service_menu_collapse_${category.productUiId}`"
        :aria-expanded="category.showCollapse ? 'true' : 'false'" data-toggle="collapse" class="service_title">{{category.name}}</a>
      <component :is="isMobile ? 'b-collapse' : 'ul'" v-model="category.showCollapse" tag="ul" :id="`service_menu_collapse_${category.productUiId}`"
        :key="categoryIdx" class="lst_service_menu">
        <li class="service_menu" :class="getServiceMenuClass(service)" v-for="service in category.services" :key="service.productUiId">
          <router-link-ex v-if="mode == 'homepage'" :to="`${serviceBasePath}${parseServiceName(category.name)}/${parseServiceName(service.name)}`"
            class="link_txt" @click.native="close()">
            <span class="service_txt" v-if="isMobile">{{service.name}}</span>
            {{isMobile ? '' : service.name}}
            <span class="service_badge" v-if="showGnbBadges(getServiceMenuClass(service))"></span>
          </router-link-ex>
          <a v-else :href="`${getDomain('homepage')}${serviceBasePath}${parseServiceName(category.name)}/${parseServiceName(service.name)}`"
            class="link_txt">{{service.name}}<span class="service_badge" v-if="showGnbBadges(getServiceMenuClass(service))"></span></a>
        </li>
      </component>
    </template>
  </div>
</template>

<script>
import { from } from 'rxjs'
import { mapActions, mapState } from 'vuex'
import { isEmpty } from 'lodash-es'
import 'bootstrap/js/dist/collapse'
import { BCollapse } from 'bootstrap-vue'

import { namespace } from '../../store/modules/common-store'
import { serviceHierarhcyService } from '../../service/service-hierarchy-service'

export default {
  components: { BCollapse },
  props: ['column', 'mode'],
  computed: {
    ...mapState(namespace, ['isMobile']),
    serviceBasePath() {
      return `${this.countryPath}/service/`
    }
  },
  watch: {
    $route() {
      from(this.column).subscribe(category => (!isEmpty(category) ? this.$set(category, 'showCollapse', false) : category))
    }
  },
  methods: {
    getServiceMenuClass: serviceHierarhcyService.getServiceMenuClass,
    toggleCollapse(category) {
      this.$set(category, 'showCollapse', !category.showCollapse)
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>
